export enum FAQTestIds {
  QUESTION = 'faq_question_container',
}
